// Profile Menu
function profileCardMenu () {
    const profileMenuCard = document.querySelector('.profile-menu-card');
    if(!profileMenuCard) return;

    profileMenuCard.addEventListener('click', function(){
        const dropdownMenu = this.querySelector('.profile-menu-dropdown');
        dropdownMenu.style.display = dropdownMenu.style.display === 'block' ? 'none' : 'block';
    });
}

document.addEventListener('DOMContentLoaded', profileCardMenu);

// Hamburger menu

function hamburgerMenu () {
    const burgerMenu = document.querySelector('.g-burger');
    if(!burgerMenu) return;

    const nav = document.querySelector('nav');
    const closeIcon = document.querySelector('.close-icon');

    burgerMenu.addEventListener('click', function(){
        nav.classList.toggle('show');
    });
    closeIcon.addEventListener('click', function(){
        nav.classList.toggle('show');
    });
}

document.addEventListener('DOMContentLoaded', hamburgerMenu);

document.addEventListener('DOMContentLoaded', () => {
    const currentYear = new Date().getFullYear();
    document.getElementById('copyright-year').textContent = currentYear;
});

// Price Panel Checkbox Toggle
function pricePanelInteraction(){
    const plans = document.querySelectorAll('.plan');

    const selectPlan = (event) => {
        // Deselect previous plan
        plans.forEach(plan =>{
            plan.classList.remove('selected');
            plan.querySelector('.hidden-checkbox').checked = false;
        });

        // Select clicked plan
        const selectedPlan = event.currentTarget;
        const checkbox = selectedPlan.querySelector('.hidden-checkbox');
        selectedPlan.classList.add('selected');
        checkbox.checked = true;
    };

    plans.forEach(plan =>{
        plan.addEventListener('click', selectPlan);
    });
}
document.addEventListener('DOMContentLoaded', pricePanelInteraction);


// Accordion collapsable

function initAccordion(selector) {
    const elements = document.querySelectorAll(selector);

    elements.forEach(element =>{
        element.addEventListener('click', function() {
            const nextSibling = this.nextElementSibling;
            nextSibling.style.display = nextSibling.style.display === 'flex' ? 'none' : 'flex';
            
            const elementIcon = this.querySelector('.action-icon');
            if(elementIcon.textContent === '+') {
                elementIcon.textContent = '-';
            } else {
                elementIcon.textContent = '+';
            }
        });
    });
}

// Accordion usage
document.addEventListener('DOMContentLoaded', () => {
    initAccordion('.accordion-heading');
});